module.exports = __webpack_public_path__ + "static/media/spinner-loading.f02efe87.gif";